import { Component, inject, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TimerService } from '@app/components/active-timer-bar/timer.service';
import {
  TaskTimerComponent,
  TaskTimerMode
} from '@app/components/task/task-state-selectors/task-timer/task-timer.component';
import { DialogService } from '@app/shared/services/shared/dialog.service';
import { UrlSegment as ProffeoUrlSegment } from '@app/shared/types/enums/url-segment.enum';
import { TaskTimer } from '@app/shared/types/models/task/task-timer';
import { Task } from '@app/shared/types/models/task/task.model';

@Component({
  selector: 'proffeo-active-timer-bar',
  templateUrl: './active-timer-bar.component.html',
  imports: [MatIconModule, TaskTimerComponent, RouterLink]
})
export class ActiveTimerBarComponent {
  private readonly timerService: TimerService = inject(TimerService);
  private readonly dialogService: DialogService = inject(DialogService);

  protected readonly ProffeoUrlSegment: typeof ProffeoUrlSegment = ProffeoUrlSegment;
  protected readonly taskTimerMode: typeof TaskTimerMode = TaskTimerMode;
  protected readonly currentTask: Signal<Task> = this.timerService.timerTask;
  protected readonly currentTimer: Signal<TaskTimer> = this.timerService.activeTimer;

  /** Opened here, not in TimerService: TimerService → DialogService would close an import cycle with the dialog. */
  protected openTimerDialog(): void {
    this.dialogService.openTimerDialog(this.timerService.timerTask());
  }

  protected buildTaskLink(): string[] {
    const task = this.currentTask();
    const project = task?.project();
    const company = project?.company();
    if (!task || !project || !company) return [];
    return [
      '/',
      ProffeoUrlSegment.COMPANIES,
      company.id,
      ProffeoUrlSegment.PROJECTS,
      project.id,
      ProffeoUrlSegment.TASKS,
      task.id
    ];
  }
}
